<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 class="mb-0">Task rules</h2>
      </sbnb-page-header>
      <h2 class="mb-0">Task rules</h2>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'ops-task-rules'"></sbnb-helptext-wrapper>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'ops-task-rules'"></sbnb-helptext-wrapper>

    <div class="rules__filters-container" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
      <sbnb-filter
        #filterComponent
        *ngIf="segmentFilterDefaults"
        fxFlex
        componentName="task-rules"
        [hideSaveSegment]="true"
        [defaultFilters]="segmentFilterDefaults"
        (filterChanged)="handleFilterChanged($event)"
        (reset)="filterReset()"></sbnb-filter>

      <sbnb-search-bar
        placeholderText="Search..."
        [initialVal]="searchCriteria"
        (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
      <button
        mat-flat-button
        data-intercom-target="add-new-task-rule"
        class="button__small button__add-new"
        (click)="openCreateDialog()">
        + Add new
      </button>
    </div>

    <ng-container *ngIf="tasks && tasks.length > 0">
      <div class="rules__container">
        <div fxLayout fxLayoutGap="19px" fxHide.lt-md class="rules__rule-header">
          <div fxFlex="32px">Status</div>
          <div fxFlex>Rule name</div>
          <div fxFlex>Task time</div>
          <div fxFlex>Properties</div>
          <div fxFlex>Assignment</div>
          <div fxFlex="40px"></div>
        </div>

        <a
          *ngFor="let task of tasks"
          fxLayout
          class="rules__rule-container"
          fxLayoutAlign="start center"
          fxLayoutGap="19px"
          [routerLink]="['/operations/task-rules/task/' + task.uuid]">
          <mat-slide-toggle
            [checked]="task.active"
            (change)="activateOrDeactivateRule(task, $event)"
            (click)="$event.stopPropagation()"></mat-slide-toggle>
          <div fxFlex fxHide.lt-md fxLayout fxLayoutAlign="start center" fxLayoutGap="16px" class="rule__title">
            {{ task.name }}
          </div>

          <div fxHide.gt-sm class="rule__title ellipsis" fxFlex>
            {{ task.name }}
            <br />
            <span class="text__small mobile__event-short" *ngIf="!task.metadata.recurring">
              {{ task.timing.unit.value ? task.timing.unit.value : 'Immediately' }}{{ task.timing.unit.value_append }}
              {{ task.timing.when }}
              <strong>{{ task.relative_to }}</strong>
            </span>
            <span class="text__small mobile__event-short" *ngIf="task.metadata.recurring">
              <strong>{{ task.relative_to | titlecase }}</strong>
              every {{ task.metadata.recurring.occurrence }}
              {{
                task.metadata.recurring.occurrence == 1
                  ? task.metadata.recurring.frequency
                  : task.metadata.recurring.frequency + 's'
              }}
            </span>
          </div>

          <div fxFlex fxHide.lt-md class="rule__when" fxLayoutAlign="start center" fxLayoutGap="8px">
            <span class="text__small" fxFlex *ngIf="!task.metadata.recurring">
              {{ task.timing.unit.value ? task.timing.unit.value : 'Immediately' }}{{ task.timing.unit.value_append }}
              {{ task.timing.when }}
              <strong>{{ task.relative_to }}</strong>
            </span>
            <span class="text__small" fxFlex *ngIf="task.metadata.recurring">
              <strong>{{ task.relative_to | titlecase }}</strong>
              every {{ task.metadata.recurring.occurrence }}
              {{
                task.metadata.recurring.occurrence == 1
                  ? task.metadata.recurring.frequency
                  : task.metadata.recurring.frequency + 's'
              }}
            </span>
          </div>

          <div fxFlex fxFlex.lt-md="none" fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-avatar-group
              [items]="task.property_list"
              [allItems]="task.all_properties"
              [itemsForLabel]="task.name"></sbnb-avatar-group>
          </div>

          <div fxFlex fxHide.lt-md fxLayoutAlign="start center" fxLayoutGap="8px">
            <sbnb-team-icon *ngIf="task.teammate" fxFlex="32px" [member]="task.teammate"></sbnb-team-icon>
            <span *ngIf="!task.teammate_name" class="text__small manual">Manual</span>
          </div>

          <div fxLayout fxHide.lt-md fxLayoutGap="8px">
            <sbnb-more-menu-trigger [matMenuTriggerFor]="actionsMenu" [suppressClick]="true"></sbnb-more-menu-trigger>
          </div>
          <mat-menu #actionsMenu="matMenu">
            <button mat-menu-item (click)="copyTaskRule(task)">
              <span fxLayoutAlign="start center" fxLayoutGap="6px">
                <img src="/assets/iconography/copy.svg" alt="Copy" />
                <span>Copy</span>
              </span>
            </button>
            <button mat-menu-item (click)="deletePrompt(task)">
              <span fxLayoutAlign="start center" fxLayoutGap="6px">
                <img src="/assets/iconography/delete.svg" alt="Delete" />
                <span>Delete</span>
              </span>
            </button>
          </mat-menu>
        </a>
      </div>
    </ng-container>

    <div *ngIf="loading">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <sbnb-no-items
      *ngIf="!loading && tasks.length === 0"
      icon="co-host"
      text="No task rules found matching these filters"
      [buttons]="[{ id: 'new', label: 'Add new task rule' }]"
      (button)="openCreateDialog()"></sbnb-no-items>

    <sbnb-pagination
      *ngIf="paginationData && !loading && paginationData.page_numbers.total_pages > 1"
      position="end"
      [pageCount]="paginationData.page_numbers.total_pages"
      [currentPage]="paginationData.page_numbers.this_page"
      (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
